<template>
  <!-- Origem Flow: o cartão ganha a cor do Status da tarefa (linha 19 da
       tabela de ajustes) para leitura visual imediata do calendário. -->
  <div
    class="calendar-card"
    :class="[
      statusOption
        ? 'calendar-card--status-colored background-color--' +
          statusOption.color
        : '',
      tableId !== null ? 'calendar-card--table-colored' : '',
    ]"
    :style="tableStripeStyle"
    :draggable="canDrag ? 'true' : 'false'"
    @click="$emit('edit-row', row)"
    @contextmenu.prevent="$emit('row-context', { row, event: $event })"
    @dragstart="onDragStart"
  >
    <RecursiveWrapper
      :components="
        wrapperDecorations.map((comp) => ({
          ...comp,
          props: comp.propsFn(row),
        }))
      "
    >
      <div class="calendar-card__content">
        <component
          :is="dec.component"
          v-for="dec in firstCellDecorations"
          :key="dec.decoration.id"
          v-bind="dec.propsFn(row)"
        />
        <div class="calendar-card__labels">
          {{ labelsText }}
        </div>
      </div>
    </RecursiveWrapper>
  </div>
</template>

<script>
import {
  sortFieldsByOrderAndIdFunction,
  filterVisibleFieldsFunction,
} from '@baserow/modules/database/utils/view'
import { getStatusField } from '@baserow/modules/database/utils/dueDate'
import { tableColorHex } from '@baserow/modules/core/utils/tableColors'
import RecursiveWrapper from '@baserow/modules/core/components/RecursiveWrapper'

export default {
  name: 'CalendarCard',
  components: { RecursiveWrapper },
  emits: ['edit-row', 'row-context'],
  props: {
    row: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    storePrefix: {
      type: String,
      required: true,
    },
    decorationsByPlace: {
      type: Object,
      required: false,
      default: () => undefined,
    },
    /**
     * Origem Flow: permite arrastar o cartão para outro dia (linha 20 da
     * tabela de ajustes) — muda a data da tarefa ao soltar.
     */
    canDrag: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Origem Flow: id da tabela dona da view — pinta a faixa esquerda do
     * cartão com a cor de identidade da tabela.
     */
    tableId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    tableStripeStyle() {
      if (this.tableId === null) {
        return {}
      }
      // A faixa é um ::before com esta variável — sobrevive aos overrides
      // de border com !important do tema escuro.
      return { '--table-color': tableColorHex(this.tableId) }
    },
    statusField() {
      return getStatusField(this.fields)
    },
    statusOption() {
      if (!this.statusField) {
        return null
      }
      return this.row[`field_${this.statusField.id}`] || null
    },
    visibleCardFields() {
      const fieldOptions =
        this.$store.getters[
          this.storePrefix + 'view/calendar/getAllFieldOptions'
        ]
      return this.fields
        .filter(filterVisibleFieldsFunction(fieldOptions))
        .sort(sortFieldsByOrderAndIdFunction(fieldOptions))
    },
    labelsText() {
      return this.visibleCardFields
        .map((f) => {
          const fieldType = this.$registry.get('field', f.type)
          const cellValue = this.row[`field_${f.id}`]
          return fieldType.toHumanReadableString(f, cellValue)
        })
        .join(' - ')
    },
    firstCellDecorations() {
      return this.decorationsByPlace?.first_cell || []
    },
    wrapperDecorations() {
      return this.decorationsByPlace?.wrapper || []
    },
  },
  methods: {
    onDragStart(event) {
      if (!this.canDrag) {
        event.preventDefault()
        return
      }
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData(
        'application/x-origem-calendar-row',
        String(this.row.id)
      )
    },
  },
}
</script>
